import React from "react";

export function EvidenceType({ ...rest }) {
  return <div {...rest}>EvidenceType</div>;
}
